// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"7b61f3ee","850":"f7c4af2f"}[chunkId] + ".chunk.js";
};